import React, { useRef, useState } from 'react';
import EmojiInserterEngine from '../../emoji-inserter/EmojiInserterEngine';
import {
  TextField,
  Divider as _Divider,
  IconButton,
  Tooltip
} from '@material-ui/core';
import {
  Subject,
  RemoveCircleOutline,
  AddCircleOutline as AddCircleIcon
} from '@material-ui/icons';
import { ConditionBuilder } from '../ConditionBuilder';
import styled from 'styled-components/macro';
import { AddButton } from '../../form-builder/FormBuilderFieldForm';
import Animation from '../../../components/Animation';
import { rgba } from 'polished';

const Divider = styled(_Divider)`
  && {
    margin: 0.8em 0;
  }
`;

const ConditionsPrefixTtitle = styled.p`
  display: flex;
  align-items: flex-end;
  padding: 0 16px;

  & > svg {
    margin-right: 0.4em;
  }
`;

const RemoveConditionBtn = styled(IconButton)`
  && {
    padding: 0;
    position: absolute;
    right: 1.2em;
  }
`;

const DescriptionWrapper = styled.div`
  transition: opacity 0.15s linear;
  opacity: ${({ removeHovered }) => (removeHovered ? 0.33 : 1)};
`;

const ActionIconButton = styled(IconButton)`
  && {
    color: #bfc5d1;
    padding: 8px;

    svg {
      font-size: 1.25rem;
    }

    &:hover {
      background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.1)};
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

const TexFieldWrapper = styled.div`
  background-color: #f7f8fc;
  padding: 16px 16px 35px;
  position: relative;
  && textarea {
    padding-right: 1rem;
  }
`;

const StyledTooltip = styled(Tooltip)`
  position: absolute !important;
  right: 1rem;
  top: 1rem;
`;

const EmojiButtonContainer = styled.div`
  position: absolute;
  right: 1rem;
  top: 0;
  && button {
    color #000 !important;
  }
`;

const DescriptionConditionBuilderView = props => {
  const { conditionsStateIndex, emojiCallback } = props;

  const [showEmojiDialog, setShowEmojiDialog] = useState(false);
  const titleRef = useRef(null);

  return (
    <>
      <ConditionsPrefixTtitle>
        <Subject />
        Show this description
        <Tooltip title="Remove description" placement="left">
          <RemoveConditionBtn
            onMouseOver={() => props.setRemovedHovered(true)}
            onMouseLeave={() => props.setRemovedHovered(false)}
            onClick={() => props.setDeleteMe(true)}
          >
            <RemoveCircleOutline />
          </RemoveConditionBtn>
        </Tooltip>
      </ConditionsPrefixTtitle>
      <Animation
        type="collapse"
        in={!props.deleteMe}
        onExited={props.removeDescription}
      >
        <DescriptionWrapper removeHovered={props.removeHovered}>
          <TexFieldWrapper>
            <TextField
              multiline
              fullWidth
              rows={5}
              variant="outlined"
              label="Field description"
              placeholder="Type your description here..."
              value={props.description}
              onChange={e =>
                props.onDescriptionChange(e, conditionsStateIndex, true)
              }
              onBlur={e =>
                props.onDescriptionChange(e, conditionsStateIndex, false)
              }
              inputProps={{ style: { paddingRight: '2rem', resize: 'vertical' } }}
              inputRef={titleRef}
            />
            <EmojiButtonContainer>
              <StyledTooltip title='emoji'>
                <ActionIconButton onClick={() => setShowEmojiDialog(true)}>
                  ☺
                </ActionIconButton>
              </StyledTooltip>
            </EmojiButtonContainer>
          </TexFieldWrapper>
          <EmojiInserterEngine
            emojiCallback={emojiCallback}
            textInput={titleRef.current}
            text={props.description}
            showEmojiDialog={showEmojiDialog}
            setShowEmojiDialog={setShowEmojiDialog}
          />
          {props.conditions.map((condition, comparisonIndex) => {
            return (
              <ConditionBuilder
                key={condition._id}
                formId={props.formId}
                internalId={props.internalId}
                conditions={props.conditions}
                condition={condition}
                update={props.updateCondition(
                  conditionsStateIndex,
                  comparisonIndex
                )}
                i={comparisonIndex}
                remove={() =>
                  props.remove(conditionsStateIndex, comparisonIndex)
                }
                rootAndOr={condition.andOr}
                updateRootAndOr={v => props.updateRootAndOr(v, comparisonIndex)}
              />
            );
          })}
        </DescriptionWrapper>
      </Animation>
      <AddButton
        data-testid={`formbuilder-add-condition`}
        color="primary"
        onClick={() => props.addCondition4Description(conditionsStateIndex)}
        startIcon={<AddCircleIcon />}
      >
        Add a condition
      </AddButton>
      <Divider />
    </>
  );
};

export default DescriptionConditionBuilderView;
